import Loadable from 'my-components/Loadable';
import TextLoading from 'my-components/TextLoading';

export default Loadable(() => import(/* webpackChunkName: "terms-and-conditions" */ './TermsAndConditionsContent'), {
  fallback: <TextLoading lines={200} />,
});
